export default {
  validatePhoneNumber: {
    error: 'Invalid phone format. Use international format: + (country code) phone number',
  },
  validateUsername: {
    error:
      'Invalid username. Use only letters, digits and ._+-@ characters. Username length must be >= 3 and <= 32.',
  },
  validateName: {
    error: 'Invalid name. Use only letters, digits and ._+- characters.',
  },
  snackbarNotifications: {
    dataUpdatedSuccess: 'Data updated',
    dataCreateSuccess: 'Data created',
    dataUpdatedFail: 'Data is not updated',
  },
  noOptions: 'No options',
  noHandbookValues: 'No options. Please, complete the solution handbook.',
  confirmation: {
    warning: 'Warning!',
    content: 'Do you really want to do this?',
    confirm: 'Confirm',
  },
  KycLevelInput: {
    label: 'KYC level',
  },
  clipboard: {
    copied: 'Copied to clipboard',
  },
  confirmConfigurationChanges: 'Confirm configuration changes?',
  any: 'Any',
  yes: 'Yes',
  no: 'No',
  balances: {
    code: {
      individuals_CURRENT_AVAILABLE: 'Available',
      individuals_CURRENT_UNAVAILABLE: 'Unavailable',
      individuals_CURRENT_POSTED: 'Posted',
      individuals_TECHNICAL_OVERDRAFT: 'Technical overdraft',
      tenant_CURRENT_AVAILABLE: 'Available',
      tenant_CURRENT_UNAVAILABLE: 'Unavailable',
      tenant_CURRENT_POSTED: 'Posted',
      tenant_CURRENT_PENDING: 'Pending (received but not available yet)',
      CURRENT_AVAILABLE: 'Available for payouts',
      CURRENT_UNAVAILABLE: 'Unavailable',
      CURRENT_POSTED: 'Posted amount',
      CURRENT_PENDING: 'Pending (received but not available yet)',
      PROCESSED_IN_REALTIME: 'Processed in Real-Time',
      CURRENT_FLOAT: 'Float',
    },
  },
  jsonEmptyArrayObjectError: 'JSON cannot be an array with an empty object',
};
